/* eslint-disable arrow-body-style */
import { Container, Paper, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const WhyChooseUsTab = () => {
  const { lang } = useTranslation('client')
  return (
    <Container size="sm">
      <Paper>
        {lang === 'en' ? (
          <div style={{ marginBottom: 30 }}>
            <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
              Why Choose Us?
            </Text>
            <Text size="lg">
              At Infinity Medical Academy, we understand that you have choices
              when it comes to selecting a training provider or educational
              institution. Here are a few reasons why we believe you should
              choose us:
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Expertise and Experience
            </Text>
            <Text size="lg">
              With years of experience in the field of Health, we have developed
              a reputation for excellence in providing high-quality training and
              educational programs. Our team of expert trainers and educators is
              dedicated to helping you achieve your professional and academic
              goals.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Tailored Solutions
            </Text>
            <Text size="lg">
              We recognize that every individual has unique learning needs and
              preferences. That&apos;s why we offer personalized training
              solutions tailored to your specific requirements. Whether
              you&apos;re looking to enhance your skills, advance your career,
              or pursue further education, we have the resources and expertise
              to support you every step of the way.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Comprehensive Curriculum
            </Text>
            <Text size="lg">
              Our comprehensive curriculum covers a wide range of topics and
              subjects relevant to health and medical. From foundational courses
              to advanced workshops, we offer a variety of learning
              opportunities designed to meet the diverse needs of our students.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Accreditation and Recognition
            </Text>
            <Text size="lg">
              Our training programs are accredited by reputable institutions and
              recognized within the industry. This ensures that you receive
              high-quality education and certification that is valued by
              employers and organizations worldwide.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Commitment to Excellence
            </Text>
            <Text size="lg">
              At Infinity Medical Academy, we are committed to excellence in
              everything we do. From our state-of-the-art facilities to our
              dedicated faculty and staff, we strive to provide an exceptional
              learning experience that exceeds your expectations.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Community and Support
            </Text>
            <Text size="lg">
              When you choose Infinity Medical Academy, you become part of a
              vibrant community of learners and professionals. Our supportive
              network of alumni, mentors, and industry partners will be there to
              support you throughout your educational journey and beyond.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Continuous Improvement
            </Text>
            <Text size="lg">
              We are constantly evolving and innovating to meet the changing
              needs of our students and the industry. Through ongoing research,
              development, and feedback, we ensure that our programs remain
              relevant, up-to-date, and aligned with industry trends and best
              practices.
            </Text>

            <Text size="lg">
              We believe that Infinity Medical Academy is more than just a
              training provider – we are your partner in success. Join us and
              take the next step towards achieving your goals.
            </Text>
          </div>
        ) : (
          <div style={{ marginBottom: 30 }} dir="rtl">
            <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
              لماذا نحن؟
            </Text>
            <Text size="lg">
              في إنفينيتي أكاديمية الطبية، ندرك أن لديك خيارات عندما يتعلق الأمر
              باختيار مزود تدريب أو مؤسسة تعليمية. إليك بعض الأسباب التي نعتقد
              أنك يجب أن تختارنا:
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              الخبرة والتجربة
            </Text>
            <Text size="lg">
              بفضل سنوات من الخبرة في مجال الصحة، قمنا بتطوير سمعة طيبة لتقديم
              برامج تدريبية وتعليمية عالية الجودة. يعمل فريقنا من المدربين
              والمعلمين الخبراء على مساعدتك في تحقيق أهدافك المهنية والأكاديمية.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              حلول مخصصة
            </Text>
            <Text size="lg">
              ندرك أن كل فرد لديه احتياجات وتفضيلات تعلم فريدة. لهذا السبب نقدم
              حلول تدريبية مخصصة مصممة لتلبية متطلباتك الخاصة. سواء كنت تبحث عن
              تعزيز مهاراتك، أو تقدم في مسارك المهني، أو متابعة التعليم العالي،
              لدينا الموارد والخبرة لدعمك في كل خطوة على الطريق.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              منهج شامل
            </Text>
            <Text size="lg">
              يغطي منهجنا الشامل مجموعة واسعة من المواضيع والمواضيع ذات الصلة
              بالصحة والطبية. من الدورات الأساسية إلى ورش العمل المتقدمة، نقدم
              مجموعة متنوعة من الفرص التعليمية المصممة لتلبية الاحتياجات
              المتنوعة لطلابنا.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              الاعتماد والتقدير
            </Text>
            <Text size="lg">
              تتمتع برامجنا التدريبية بالاعتماد من مؤسسات موثوقة والتقدير داخل
              الصناعة. وهذا يضمن أن تحصل على تعليم وشهادة عالية الجودة يقدرها
              أصحاب العمل والمنظمات في جميع أنحاء العالم.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              التزام بالتميز
            </Text>
            <Text size="lg">
              في إنفينيتي أكاديمية الطبية، نحن ملتزمون بالتميز في كل ما نقوم به.
              من مرافقنا المتطورة إلى هيئة التدريس والموظفين المخصصة لدينا، نسعى
              جاهدين لتوفير تجربة تعليمية استثنائية تتجاوز توقعاتك.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              المجتمع والدعم
            </Text>
            <Text size="lg">
              عندما تختار إنفينيتي أكاديمية الطبية، فأنت تصبح جزءًا من مجتمع
              نابض بالحياة من المتعلمين والمهنيين. ستكون شبكتنا الداعمة من
              الخريجين والمرشدين وشركاء الصناعة هنا لدعمك طوال رحلتك التعليمية
              وما بعدها.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              التحسين المستمر
            </Text>
            <Text size="lg">
              نحن نتطور باستمرار ونبتكر لتلبية الاحتياجات المتغيرة لطلابنا
              والصناعة. من خلال البحث المستمر والتطوير والتغذية المرتدة، نضمن أن
              برامجنا تبقى ذات صلة وحديثة ومتماشية مع اتجاهات الصناعة وأفضل
              الممارسات.
            </Text>

            <Text size="lg">
              نعتقد أن إنفينيتي أكاديمية الطبية ليست مجرد مزود للتدريب - نحن
              شريكك في النجاح. انضم إلينا واتخذ الخطوة التالية نحو تحقيق أهدافك.
            </Text>
          </div>
        )}
      </Paper>
    </Container>
  )
}

export default WhyChooseUsTab
